// The payment-terms band that closes EVERY outgoing invoice — tax, excess,
// quoted, quote fee and progress claim (Robert 2026-08-04: "a reusable band, so
// if we change it anywhere it changes on all invoices").
//
// It earns its own file: before this, the tax invoice promised payment "within
// 10 days as per preferred supplier agreement" while the progress claim
// promised "by the 20th of the month following invoice" — two different terms
// leaving the building under one letterhead, and 1.0 says 10 days on both.
// One copy of the words is the only way that stays fixed.
//
// STYLING — deliberately not 1.0's. The legacy band is centred and half in red,
// which reads as a warning; these are terms, not a warning, and red on paper is
// the house style of a 1990s report writer. It stays quiet EXCEPT for the bank
// account number, which is the one line where a misreading costs real money.
// Emphasis where a mistake is expensive, restraint everywhere else.
//
// `reference` is the invoice number or ref to quote when paying. 1.0 asks only
// for "the invoice number"; naming it removes the guess.
const TERMS = {
  days: "Payment due within 10 days as per preferred supplier agreement.",
  contact: (phone) => `Please contact Accounts ${phone} if for any reason payment terms cannot be met.`,
  phone: "09-622 3900",
  bank: "12-3252-0067539-00 (ASB)",
};

function PaymentTerms({ reference = null }) {
  return (
    <div className="mt-4 pt-3 small" style={{ borderTop: "1px solid #dee2e6" }}>
      <div className="fw-semibold text-uppercase mb-1">Payment Terms</div>
      <div>{TERMS.days}</div>
      <div>{TERMS.contact(TERMS.phone)}</div>
      <div>
        Bank account: <strong>{TERMS.bank}</strong>. If paying by direct debit, please state
        {reference ? <> invoice <strong>{reference}</strong></> : " the invoice number"} in the particulars.
      </div>
    </div>
  );
}

export default PaymentTerms;
